import React from 'react';
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import t from "../../Utils/Translation";
import { 
  AUTHORIZED_URL_PREFIX, 
  PROFILE_URL,
  NOTIFICATION_SEVERITY_WARNING,
  AxiosConfig 
} from '../../Utils/Constants';
import { LykioContext } from '../routing/LykioAuthorizedRoute';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';

const EniRadarChart = () => {
    const context = useContext(LykioContext);
    const user = context.userDetails;
    const [ bestResult, setBestResult ] = useState([]);
    const [ averageResults, setAverageResults ] = useState([]);
    const [ userResults, setUserResults ] = useState([]);

    useEffect(() => {
      const fetchData = async() => {
        try {
          const { data } = await axios.post(
            `${AUTHORIZED_URL_PREFIX}${'/user/getBiasScores'}`,
            { user: user },
            AxiosConfig()
          );
          if (data.success) {
            setBestResult(data.bestResult);
            setAverageResults(data.averageResults);
            setUserResults(data.userResults);
          } else {
            notify(pleaseRefreshError);
          }
        } catch (error) {
          console.log(error);
          notify({
            title: `${t('Could not retrieve bias scores. Please refresh.')}`,
            severity: NOTIFICATION_SEVERITY_WARNING,
            creationDate: ''
          });
        }
      }

      fetchData();
    }, []);

    ChartJS.register(
        RadialLinearScale,
        PointElement,
        LineElement,
        Filler,
        Tooltip,
        Legend
      );

      const data1 = {
        labels: [
          `${t("Gender bias")}`,
          `${t("Age bias")}`,
          `${t("Ethnicity bias")}`,
          `${t("Cognitive biases")}`,
          `${t("Cultural bias")}`,
        ],
        datasets: [
          {
            label: "BIAS FREE (baseline)",
            backgroundColor: "grey",
            borderColor: "grey",
            pointBackgroundColor: "grey",
            pointBorderColor: "grey",
            pointHoverBackgroundColor: "grey",
            pointHoverBorderColor: "grey",
            data: [0, 0, 0, 0, 0],
          },
          {
            label: `${t("Best result amongst players")}`,
            backgroundColor: "rgba(1,0,255,0)",
            borderColor: "rgba(1,0,255,1)",
            pointBackgroundColor: "rgba(1,0,255,1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgba(1,0,255,0)",
            data: bestResult,
          },
          {
            label: `${t("Average result amongst players")}`,
            backgroundColor: "rgba(0,215,0,0)",
            borderColor: "rgba(0,215,0,1)", // green
            pointBackgroundColor: "rgba(0,215,0,1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgba(0,215,0,1)",
            data: averageResults,
          },
          {
            label: `${t("My result")}`,
            backgroundColor: "rgba(255,0,0,0)",
            borderColor: "rgba(255,0,0,1)",
            pointBackgroundColor: "rgba(255,0,0,1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgba(255,0,0,0)",
            data: userResults,
          },
        ],
      };

  return (
    <Radar data={data1} />
  );
}




export default EniRadarChart;






